import { BREAKPOINT } from "@constants";

const getDeviceWidth = (): number => {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

const isMobileBreakpoint = (): boolean => {
  const deviceWidth = getDeviceWidth();

  return deviceWidth < BREAKPOINT.sm;
};

const isDesktopBreakpoint = () => {
  const deviceWidth = getDeviceWidth();

  return deviceWidth >= BREAKPOINT.sm;
};

export default {
  getDeviceWidth,
  isMobileBreakpoint,
  isDesktopBreakpoint,
};
